import PageBanner from "@/components/feature/PageBanner";
import ContactForm from "@/components/feature/ContactForm";
import { useApi } from "@/hooks/useApi";
import type { ClubFull } from "@/lib/types";

export default function ContactPage() {
  const { data } = useApi<ClubFull>("club.php");

  return (
    <>
      <PageBanner
        title="문의하기"
        description="클럽에 궁금한 점이나 가입 문의를 남겨주세요."
        breadcrumb={[{ label: "문의하기" }]}
      />

      <section className="mx-auto max-w-4xl px-4 md:px-6 py-10 md:py-12">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.4fr] gap-8">
          {/* 안내 + 연락처 */}
          <div className="space-y-4">
            <div className="rounded-xl border border-background-200 bg-background-100 p-5">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-500 text-primary-950">
                <i className="ri-mail-send-line text-lg" aria-hidden="true"></i>
              </span>
              <h2 className="mt-4 font-heading text-base font-bold text-foreground-950">
                문의 안내
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                가입 문의, 봉사 참여, 홈페이지 이용에 대한 의견을 남겨주시면
                확인 후 순차적으로 연락드리겠습니다.
              </p>
            </div>

            {(data?.tel || data?.email || data?.addr) && (
              <ul className="space-y-3">
                {data?.tel && (
                  <li className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
                    <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                      <i className="ri-phone-line" aria-hidden="true"></i>
                    </span>
                    <a
                      href={`tel:${data.tel.replace(/[^0-9+]/g, "")}`}
                      className="text-sm font-medium text-foreground-800 hover:text-primary-700"
                    >
                      {data.tel}
                    </a>
                  </li>
                )}
                {data?.email && (
                  <li className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
                    <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                      <i className="ri-mail-line" aria-hidden="true"></i>
                    </span>
                    <a
                      href={`mailto:${data.email}`}
                      className="text-sm font-medium text-foreground-800 hover:text-primary-700 break-all"
                    >
                      {data.email}
                    </a>
                  </li>
                )}
                {data?.addr && (
                  <li className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
                    <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                      <i className="ri-map-pin-line" aria-hidden="true"></i>
                    </span>
                    <span className="text-sm font-medium text-foreground-800">{data.addr}</span>
                  </li>
                )}
              </ul>
            )}
          </div>

          {/* 문의 폼 */}
          <div className="rounded-xl border border-background-200 bg-background-50 p-5 md:p-7">
            <h2 className="font-heading text-lg font-bold text-foreground-950">
              문의 남기기
            </h2>
            <p className="mt-1 mb-5 text-sm text-foreground-500">
              <span className="text-accent-600">*</span> 표시는 필수 입력 항목입니다.
            </p>
            <ContactForm />
          </div>
        </div>
      </section>
    </>
  );
}